export const PROMOTION_QUERY_LIMIT = 10;
export const PROMOTION_SHORT_NAME_LIMIT = 15;
